import _ from 'lodash';

import B2BApi from '../../../../api/b2b-api';
import b2bActionTypes from '../constants/action-types';
import B2BHelpers from '../helpers/b2b-helpers';
import constants from '../../../../common/constants';
import { handleHttpInProgress } from '../../../shared/http-in-progress/actions/http-in-progress-actions';
import { toggleInfoModal, toggleDefaultErrorModal } from '../../../shared/info-modal/actions/info-modal-actions';

export const getKeys = () => {
  return async dispatch => {
    dispatch(handleHttpInProgress(true));
    try {
      const response = await B2BApi.getKeys();
      const keys = response && response.data ? _.orderBy(response.data, ['creation_date'], ['desc']) : [];
      dispatch(handleSuccessGetKeys(keys));
      dispatch(handleHttpInProgress(false));
    } catch (error) {
      dispatch(handleHttpInProgress(false));
    }
  };
};

export const generateKey = () => {
  return async dispatch => {
    dispatch(generateKeyInProgress(true));
    try {
      await B2BApi.generateKey();
      dispatch(toggleInfoModal(true, constants.info_modal_types.success.value, 'B2B.SUCCESS_GENERATE_KEY'));
      dispatch(generateKeyInProgress(false));
      dispatch(getKeys());
    } catch (error) {
      dispatch(toggleDefaultErrorModal());
      dispatch(generateKeyInProgress(false));
    }
  };
};

export const deactivateKey = (key, keys) => {
  return async dispatch => {
    dispatch(deactivateKeyInProgress(true));
    try {
      await B2BApi.deactivateKey(key);
      keys = B2BHelpers.adjustKeys(keys, key, true);
      dispatch(handleSuccessGetKeys(keys));
      dispatch(toggleDeactivateKeyModal(false, null));
      dispatch(deactivateKeyInProgress(false));
      dispatch(
        toggleInfoModal(true, constants.info_modal_types.success.value, 'B2B.SUCCESS_DEACTIVATE_KEY', {
          key: key,
        })
      );
    } catch (error) {
      dispatch(toggleDefaultErrorModal());
      dispatch(deactivateKeyInProgress(false));
    }
  };
};

export const revealApiSecret = (key, keys) => {
  return async dispatch => {
    try {
      const response = await B2BApi.revealApiSecret(key);
      keys = B2BHelpers.adjustKeys(keys, key, false, response.data.api_secret);
      dispatch(handleSuccessGetKeys(keys));
    } catch (error) {
      dispatch(toggleDefaultErrorModal());
    }
  };
};

export const handleSuccessGetKeys = keys => {
  return {
    type: b2bActionTypes.HANDLE_SUCCESS_GET_KEYS,
    data: keys,
  };
};

export const toggleDeactivateKeyModal = (show, key) => {
  return {
    type: b2bActionTypes.TOGGLE_DEACTIVATE_KEY_MODAL,
    data: {
      show,
      key,
    },
  };
};

export const deactivateKeyInProgress = inProgress => {
  return {
    type: b2bActionTypes.DEACTIVATE_KEY_IN_PROGRESS,
    data: inProgress,
  };
};

export const generateKeyInProgress = inProgress => {
  return {
    type: b2bActionTypes.GENERATE_KEY_IN_PROGRESS,
    data: inProgress,
  };
};



// WEBPACK FOOTER //
// ./src/app/main/b2b/actions/b2b-actions.js